import { render, staticRenderFns } from "./Vue3Parent.vue?vue&type=template&id=1db64270&scoped=true"
import script from "./Vue3Parent.vue?vue&type=script&lang=js"
export * from "./Vue3Parent.vue?vue&type=script&lang=js"
import style0 from "./Vue3Parent.vue?vue&type=style&index=0&id=1db64270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db64270",
  null
  
)

export default component.exports